
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1126"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1126"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("912Pr", function(module, exports) {
// scripts.js

var $cP3LP = parcelRequire("cP3LP");
// Global flag to prevent typewriter duplication
if (window.typewriterRunning === undefined) window.typewriterRunning = false;
document.addEventListener("DOMContentLoaded", ()=>{
    const adminMenuButton = document.getElementById("adminMenuButton");
    const adminMenuOptions = document.getElementById("adminMenuOptions");
    if (adminMenuButton) {
        // Only run admin menu logic if the button exists
        $690666c4ded022b8$var$updateAdminMenu();
        if (adminMenuOptions) // Ensure adminMenuOptions also exists before adding listener
        adminMenuButton.addEventListener("click", ()=>{
            if (adminMenuOptions.style.display === "none" || adminMenuOptions.style.display === "") adminMenuOptions.style.display = "block";
            else adminMenuOptions.style.display = "none";
        });
    }
    if (window.location.pathname.endsWith("pricing.html")) {
        $690666c4ded022b8$var$fetchAndDisplayCurrentSubscription();
        const currentPlanInfoDiv = document.getElementById("current-plan-info");
        currentPlanInfoDiv.addEventListener("click", async (e)=>{
            if (e.target.classList.contains("btn-cancel-subscription")) {
                const accessToken = localStorage.getItem("access_token");
                if (!accessToken) {
                    (0, $cP3LP.showToast)("Please log in to cancel subscription.", "error");
                    setTimeout(()=>{
                        window.location.href = "login.html";
                    }, 2000);
                    return;
                }
                $690666c4ded022b8$var$showConfirmationDialog("Are you sure you want to cancel your subscription?", async (confirmed)=>{
                    if (confirmed) {
                        (0, $cP3LP.showGlobalPreloader)("Cancelling subscription...");
                        try {
                            const cancelResponse = await fetch("/api/billing/cancel", {
                                method: "POST",
                                headers: {
                                    Authorization: `Bearer ${accessToken}`
                                }
                            });
                            const cancelData = await cancelResponse.json();
                            if (cancelResponse.ok) {
                                (0, $cP3LP.showToast)("Subscription canceled successfully!", "success");
                                setTimeout(()=>{
                                    location.reload();
                                }, 2000);
                            } else {
                                let errorMessage = "An unknown error occurred during cancellation.";
                                if (cancelData && cancelData.error) errorMessage = cancelData.error;
                                else if (cancelResponse.status) errorMessage = `Error: ${cancelResponse.status} ${cancelResponse.statusText || ""}`;
                                (0, $cP3LP.showToast)(`Cancellation failed: ${errorMessage}`, "error");
                            }
                        } catch  {
                            (0, $cP3LP.showToast)("An error occurred during cancellation. Please try again.", "error");
                        } finally{
                            (0, $cP3LP.hideGlobalPreloader)();
                        }
                    }
                });
            }
        });
        const subscribeButtons = document.querySelectorAll(".btn-subscribe");
        subscribeButtons.forEach((button)=>{
            button.addEventListener("click", async (e)=>{
                const planId = e.target.dataset.planId;
                const accessToken = localStorage.getItem("access_token");
                if (!accessToken) {
                    (0, $cP3LP.showToast)("Please log in to subscribe.", "error");
                    setTimeout(()=>{
                        window.location.href = "login.html";
                    }, 2000);
                    return;
                }
                try {
                    (0, $cP3LP.showGlobalPreloader)("Initiating subscription...");
                    const response = await fetch("/api/subscriptions/subscribe", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${accessToken}`
                        },
                        body: JSON.stringify({
                            plan_id: planId
                        })
                    });
                    let data;
                    try {
                        data = await response.json();
                    } catch  {
                        data = await response.text();
                    }
                    if (response.ok) {
                        (0, $cP3LP.hideGlobalPreloader)(); // Hide preloader before opening Razorpay
                        const options = {
                            key: data.razorpay_key_id,
                            amount: data.amount,
                            currency: "INR",
                            name: "LukaIN",
                            description: `Subscription to ${planId} plan`,
                            order_id: data.order_id,
                            handler: async (response)=>{
                                (0, $cP3LP.showGlobalPreloader)("Verifying payment...");
                                const verifyResponse = await fetch("/api/billing/verify_payment", {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json",
                                        Authorization: `Bearer ${accessToken}`
                                    },
                                    body: JSON.stringify({
                                        plan_id: planId,
                                        payment_id: response.razorpay_payment_id,
                                        order_id: response.razorpay_order_id,
                                        signature: response.razorpay_signature,
                                        amount: data.amount
                                    })
                                });
                                const verifyData = await verifyResponse.json().catch(()=>verifyResponse.text());
                                if (verifyResponse.ok) {
                                    if (verifyData.access_token) localStorage.setItem("access_token", verifyData.access_token);
                                    (0, $cP3LP.showToast)("Subscription successful!", "success");
                                    setTimeout(()=>{
                                        location.reload();
                                    }, 2000);
                                } else {
                                    let errorMessage = "An unknown error occurred during verification.";
                                    if (typeof verifyData === "string") errorMessage = verifyData;
                                    else if (verifyData && verifyData.error) errorMessage = verifyData.error;
                                    else if (verifyData && verifyData.msg) errorMessage = verifyData.msg;
                                    (0, $cP3LP.showToast)(`Subscription failed: ${errorMessage}`, "error");
                                }
                                (0, $cP3LP.hideGlobalPreloader)();
                            }
                        };
                        const rzp = new Razorpay(options);
                        rzp.open();
                    } else {
                        let errorMessage = "An unknown error occurred.";
                        if (typeof data === "string") errorMessage = data;
                        else if (data && data.error) errorMessage = data.error;
                        else if (data && data.msg) errorMessage = data.msg;
                        else if (response.status) errorMessage = `Error: ${response.status} ${response.statusText || ""}`;
                        (0, $cP3LP.showToast)(`Subscription failed: ${errorMessage}`, "error");
                        (0, $cP3LP.hideGlobalPreloader)();
                    }
                } catch  {
                    (0, $cP3LP.showToast)("An error occurred while subscribing. Please try again.", "error");
                    (0, $cP3LP.hideGlobalPreloader)();
                }
            });
        });
    }
});
function $690666c4ded022b8$var$updateAdminMenu() {
    const adminMenuContainer = document.getElementById("adminMenuContainer");
    const adminMenuOptions = document.getElementById("adminMenuOptions");
    const token = localStorage.getItem("access_token");
    if (!token) {
        if (adminMenuContainer) adminMenuContainer.style.display = "none";
        return;
    }
    let role = "";
    try {
        const payload = (0, $cP3LP.get_parsed_jwt_identity)();
        if (payload && payload.user_data) try {
            const userData = typeof payload.user_data === 'string' ? JSON.parse(payload.user_data) : payload.user_data;
            if (userData && userData.role) role = userData.role;
        } catch  {
            role = "";
        }
    } catch  {
        role = "";
    }
    if (role === "admin" || role === "chairman") {
        if (adminMenuContainer) adminMenuContainer.style.display = "inline-block";
        if (adminMenuOptions) {
            adminMenuOptions.innerHTML = "";
            // Add User Management link
            const teacherManagementLink = document.createElement("a");
            teacherManagementLink.href = "member_management.html";
            teacherManagementLink.textContent = "User Management";
            teacherManagementLink.classList.add("nav-item");
            adminMenuOptions.appendChild(teacherManagementLink);
            // Add Timetable Management link
            const timetableManagementLink = document.createElement("a");
            timetableManagementLink.href = "timetable_management.html";
            timetableManagementLink.textContent = "Timetable Management";
            timetableManagementLink.classList.add("nav-item");
            adminMenuOptions.appendChild(timetableManagementLink);
            // Add Get Member Codes link
            const getTeacherCodesLink = document.createElement("a");
            getTeacherCodesLink.href = "get_member_codes.html";
            getTeacherCodesLink.textContent = "Get Member Codes";
            getTeacherCodesLink.classList.add("nav-item");
            adminMenuOptions.appendChild(getTeacherCodesLink);
            // Show Admin Approval link only for chairman
            if (role === "chairman") {
                const adminApprovalLink = document.createElement("a");
                adminApprovalLink.href = "admin_approval.html";
                adminApprovalLink.textContent = "Account Approval";
                adminApprovalLink.classList.add("nav-item");
                adminMenuOptions.appendChild(adminApprovalLink);
                const superAdminDashboardLink = document.createElement("a");
                superAdminDashboardLink.href = "superadmindashboard.html";
                superAdminDashboardLink.textContent = "Owner Dashboard";
                superAdminDashboardLink.classList.add("nav-item");
                adminMenuOptions.appendChild(superAdminDashboardLink);
            }
            // Show Deletion Approval link for both admin and chairman
            const deletionApprovalLink = document.createElement("a");
            deletionApprovalLink.href = "deletion_approval.html";
            deletionApprovalLink.textContent = "Account Deletion Approval";
            deletionApprovalLink.classList.add("nav-item");
            adminMenuOptions.appendChild(deletionApprovalLink);
        }
    } else if (adminMenuContainer) adminMenuContainer.style.display = "none";
}
// Function to fetch and display current subscription
async function $690666c4ded022b8$var$fetchAndDisplayCurrentSubscription() {
    const currentPlanInfoDiv = document.getElementById("current-plan-info");
    if (!currentPlanInfoDiv) return;
    (0, $cP3LP.showGlobalPreloader)("Loading subscription info...");
    const subscribeButtons = document.querySelectorAll(".btn-subscribe");
    const accessToken = localStorage.getItem("access_token");
    if (!accessToken) {
        currentPlanInfoDiv.innerHTML = "<p>Please log in to view your current plan.</p>";
        (0, $cP3LP.hideGlobalPreloader)();
        return;
    }
    try {
        const response = await fetch("/subscriptions/subscription", {
            method: "GET",
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        });
        if (response.ok) {
            const data = await response.json();
            const currentPlanId = data.plan_id;
            const currentPlanName = data.plan_id.charAt(0).toUpperCase() + data.plan_id.slice(1);
            currentPlanInfoDiv.innerHTML = `<p>Your current plan: <strong>${currentPlanName}</strong></p>`;
            // Disable buttons for current or lower plans
            subscribeButtons.forEach((button)=>{
                const planId = button.dataset.planId;
                if (planId === currentPlanId) {
                    button.textContent = "Current Plan";
                    button.disabled = true;
                    button.classList.add("btn-current-plan");
                } else if (planId === "basic" && currentPlanId === "premium" || planId === "free" && (currentPlanId === "basic" || currentPlanId === "premium")) {
                    button.disabled = true;
                    button.classList.add("btn-disabled");
                }
            });
            // Add cancel subscription button if not free
            if (currentPlanId !== "free") {
                const cancelButton = document.createElement("button");
                cancelButton.textContent = "Cancel Subscription";
                cancelButton.classList.add("btn-primary", "btn-cancel-subscription");
                currentPlanInfoDiv.appendChild(cancelButton);
            }
        } else if (response.status === 404) // No active subscription found, so we can allow the user to subscribe to any plan.
        currentPlanInfoDiv.innerHTML = "<p>You do not have an active subscription.</p>";
        else // Other errors fetching subscription
        currentPlanInfoDiv.innerHTML = "<p>Error loading current plan.</p>";
    } catch  {
        /* console.error("Error fetching current subscription:", error); */ currentPlanInfoDiv.innerHTML = "<p>An error occurred while loading current plan.</p>";
    } finally{
        (0, $cP3LP.hideGlobalPreloader)();
    }
}
function $690666c4ded022b8$var$showConfirmationDialog(message, callback) {
    const confirmationDialog = document.getElementById("confirmation-dialog");
    document.querySelector("#confirmation-dialog p").textContent = message;
    confirmationDialog.style.display = "flex";
    const confirmYesButton = document.getElementById("confirm-yes");
    const confirmNoButton = document.getElementById("confirm-no");
    confirmYesButton.onclick = ()=>{
        confirmationDialog.style.display = "none";
        callback(true);
    };
    confirmNoButton.onclick = ()=>{
        confirmationDialog.style.display = "none";
        callback(false);
    };
}

});

parcelRegister("9DUBZ", function(module, exports) {

$parcel$export(module.exports, "typeWriter", () => $01cfcd1698ded080$export$245947e8fe008c97);
function $01cfcd1698ded080$export$245947e8fe008c97(element, text, speed = 100) {
    let i = 0;
    function type() {
        if (i < text.length) {
            element.innerHTML += text.charAt(i);
            i++;
            setTimeout(type, speed);
        }
    }
    type();
}

});

parcelRegister("8zuxV", function(module, exports) {
function $019c4760db7c5676$var$initializeAnimations() {
    // Intersection Observer for scroll animations
    const animateOnScrollElements = document.querySelectorAll("main [data-animation], .main-header [data-animation], .main-footer-dark [data-animation]");
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                const element = entry.target;
                const animationType = element.dataset.animation;
                const delay = parseInt(element.dataset.delay) || 0;
                setTimeout(()=>{
                    element.classList.remove("animate-hidden"); // Remove initial hidden state
                    element.classList.add("animated", animationType);
                }, delay);
                // Stop observing once animated
                observer.unobserve(element);
            }
        });
    }, {
        threshold: 0.1
    });
    animateOnScrollElements.forEach((el)=>{
        // Add a class to hide elements initially, before animation
        el.classList.add("animate-hidden");
        observer.observe(el);
    });
    // Initial Page Load Animations (for elements immediately visible)
    const initialLoadElements = document.querySelectorAll("main [data-animation]");
    initialLoadElements.forEach((el, index)=>{
        // Exclude elements that are handled by the IntersectionObserver for on-scroll animations
        // or elements that are part of the hero section (handled by landing.js)
        if (!el.closest(".hero-content")) {
            // Exclude hero content
            const animationType = el.dataset.animation;
            const delay = parseInt(el.dataset.delay) || index * 150; // Increased stagger delay
            el.classList.add("animate-hidden"); // Ensure hidden initially
            setTimeout(()=>{
                el.classList.remove("animate-hidden");
                el.classList.add("animated", animationType);
            }, delay);
        }
    });
}
document.addEventListener("DOMContentLoaded", ()=>{
    $019c4760db7c5676$var$initializeAnimations();
});
window.initializeAnimations = $019c4760db7c5676$var$initializeAnimations;

});

parcelRequire("912Pr");

var $9DUBZ = parcelRequire("9DUBZ");
parcelRequire("8zuxV");
async function $4103870a7886fc98$var$loadLiveStatsAndCount() {
    let live = null;
    try {
        const res = await fetch("/api/public/platform-stats", {
            method: "GET"
        });
        if (res.ok) live = await res.json();
    } catch  {
        live = null;
    }
    if (live) {
        const map = [
            [
                "stat-hq",
                "global_hq",
                1
            ],
            [
                "stat-orgs",
                "total_organizations",
                0
            ],
            [
                "stat-uptime",
                "uptime_percent",
                99.9
            ],
            [
                "stat-support",
                "support_hours",
                24
            ],
            [
                "stat-modules",
                "core_modules",
                8
            ],
            [
                "stat-founded",
                "year_founded",
                2025
            ]
        ];
        for (const [id, key, fallback] of map){
            const el = document.getElementById(id);
            if (!el) continue;
            const value = live && typeof live[key] === "number" ? live[key] : fallback;
            el.setAttribute("data-count", String(value));
        }
    }
    $4103870a7886fc98$var$startCountAnimations();
}
function $4103870a7886fc98$var$startCountAnimations() {
    const statNumbers = document.querySelectorAll(".stat-number[data-count]");
    const duration = 1600;
    const startTs = performance.now();
    function tick(now) {
        const progress = Math.min(1, (now - startTs) / duration);
        const eased = 1 - Math.pow(1 - progress, 3);
        statNumbers.forEach((el)=>{
            const target = parseFloat(el.getAttribute("data-count") || "0");
            if (!Number.isFinite(target)) return;
            const current = target * eased;
            const display = Number.isInteger(target) ? Math.floor(current).toLocaleString("en-US") : current.toFixed(target % 1 === 0 ? 0 : 1);
            el.textContent = display;
        });
        if (progress < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
}
document.addEventListener("DOMContentLoaded", ()=>{
    const typingHeading = document.getElementById("typing-heading");
    if (typingHeading) {
        typingHeading.textContent = "";
        (0, $9DUBZ.typeWriter)(typingHeading, "Redefining Management");
    }
    $4103870a7886fc98$var$loadLiveStatsAndCount();
});


//# sourceMappingURL=about.757742c7.js.map
